
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 5.5a.75.75 0 001.5 0h-1.5zm1.5-4a.75.75 0 00-1.5 0h1.5zm6.5 4a.75.75 0 001.5 0h-1.5zm1.5-4a.75.75 0 00-1.5 0h1.5zM5 8.25a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm-.5 2a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm4.5-5a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm4.5-1.5a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm-5.5 2a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm4.5-1.5a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm-.5 1.5a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zm-5.5-1.5a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zM5 14.75a.75.75 0 000 1.5v-1.5zm.5 1.5a.75.75 0 000-1.5v1.5zM3 4.25h14v-1.5H3v1.5zM18.25 5.5v12h1.5v-12h-1.5zM17 18.75H3v1.5h14v-1.5zM1.75 17.5v-12H.25v12h1.5zM3 18.75c-.69 0-1.25-.56-1.25-1.25H.25A2.75 2.75 0 003 20.25v-1.5zm15.25-1.25c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 002.75-2.75h-1.5zM17 4.25c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0017 2.75v1.5zM3 2.75A2.75 2.75 0 00.25 5.5h1.5c0-.69.56-1.25 1.25-1.25v-1.5zM6.75 5.5v-4h-1.5v4h1.5zm8 0v-4h-1.5v4h1.5zM5 9.75h.5v-1.5H5v1.5zm0 3.5h.5v-1.5H5v1.5zm5-3.5h.5v-1.5H10v1.5zm5 0h.5v-1.5H15v1.5zm-5 3.5h.5v-1.5H10v1.5zm5 0h.5v-1.5H15v1.5zm0 3h.5v-1.5H15v1.5zm-5 0h.5v-1.5H10v1.5zm-5 0h.5v-1.5H5v1.5z"}})])
          )
        }
      }
    